<template>
    <div>
        <v-row class="mb-0 d-flex">
            <v-col cols="6" sm="8" :md="10" class="mb-0 pb-0">
                <v-text-field
                v-model="searchText"
                class="search"
                :label="$t('search')"
                prepend-inner-icon="mdi-magnify"
                @keypress.enter="searchForm"
                @blur="searchForm"
            ></v-text-field>
            </v-col>
            <v-col cols="6" sm="4" :md="2" class="mb-0 pb-0 d-flex align-end">
                <v-btn
                    text
                    @click="openSearchAdvanced"
                    class="buttonAdvanced"
                    :class="{'active':searchState}"
                >
                    {{$t('advanced-search')}}
                    <span v-show="searchState">
                        <img src="/images/_SVGs/menu-down.svg" class="ml-2" onload="SVGInject(this)" width="12" />
                    </span>
                    <span v-show="!searchState">
                        <img src="/images/_SVGs/chevron-double-right.svg" class="ml-2" onload="SVGInject(this)" width="12" />
                    </span>
                </v-btn>

            </v-col>

            <v-col cols="12" class="mb-0 pb-0 pt-0">
                <hr class="mb-0 mt-0">
            </v-col>

        </v-row>

        <!--Type User-->
        <v-row class="d-flex filter-advenced" v-if="searchState" >

            <v-col cols="12" :sm="3">
                <v-row align="center">
                    <v-col cols="12">
                        <v-menu
                            ref="menu"
                            v-model="menu"
                            :close-on-content-click="false"
                            :return-value.sync="date"
                            transition="scale-transition"
                            offset-y
                            max-width="290px"
                            min-width="auto"
                        >
                            <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                                prepend-icon="mdi-calendar"
                                readonly
                                v-bind="attrs"
                                v-on="on"
                                v-model="dateRangeText"
                                :label="$t('environmental-management.scheduling.search-order-without-route.request-date')"
                                clearable
                            ></v-text-field>
                            </template>

                            <v-date-picker
                            v-model="form.dates"
                            range
                            >
                            <v-spacer></v-spacer>
                            <v-btn
                                text
                                color="primary"
                                @click="menu = false"
                            >
                                {{$t('cancel')}}
                            </v-btn>
                            <v-btn
                                text
                                color="primary"
                                @click="$refs.menu.save(date)"
                            >
                                {{$t('ok')}}
                            </v-btn>
                            </v-date-picker>
                        </v-menu>
                    </v-col>
                </v-row>
            </v-col>

            <v-col cols="12" :sm="4">
                <v-row align="center">
                    <v-col cols="4" sm="4">
                        <v-subheader>
                            {{$t('environmental-management.scheduling.search-order-without-route.nif-producer')}}
                        </v-subheader>
                    </v-col>
                    <v-col cols="8" sm="6">
                        <v-text-field
                            v-model="form.nifProdutor"
                            :label="$t('environmental-management.scheduling.search-order-without-route.nif-label')"
                        ></v-text-field>
                    </v-col>
                </v-row>
            </v-col>

            <v-col cols="12" :sm="3">
                <v-row align="center">
                    <v-col cols="4" sm="4">
                        <v-subheader>
                            {{$t('environmental-management.scheduling.search-order-without-route.apa-code')}}
                        </v-subheader>
                    </v-col>

                    <v-col cols="8" sm="6">
                        <v-text-field
                            v-model="form.apaCodeProdutor"
                            :label="$t('environmental-management.scheduling.search-order-without-route.apa-label')"
                        ></v-text-field>
                    </v-col>
                </v-row>
            </v-col>


            <v-col cols="12" :sm="2" class="mt-3 text-md-right text-center mb-3 mb-sm-0">
                <BaseButton :height='40' :width="100" @click="searchForm" class="float-none float-sm-right">
                    {{$t('search')}} »
                </BaseButton>
            </v-col>

        </v-row>

    </div>
</template>

<script>
    import BaseButton from '@components/backoffice/widgets/BaseButton';
    export default {
        components : {
            BaseButton
        },
        props: {
            type: String,
            saldo: Array,
            services: Array
        },
        data () {
            return{
                searchState: false,
                searchText: '',
                dates:[],

                form:{
                    searchText:'',
                    dates:[],
                    nifProdutor: '',
                    apaCodeProdutor: '',
                },


                menu: false,
                modal: false,
                date: '',
                dateRangeText: ''
            }
        },
        watch: {
            "form.dates": {
                handler() {
                    if(this.form.dates){
                        this.dateRangeText = this.form.dates.join(' ~ ')
                    }
                },
            },
            dateRangeText: {
                handler: function(newValue, oldValue)  {
                    if(newValue == null){
                        this.form.dates = []
                    }
                },
            },
        },
        methods:{
            openSearchAdvanced(){
                this.searchState = !this.searchState
            },
            searchForm(){
                this.form.searchText = this.searchText;
                this.$emit('on-search', this.form);
            }
        },
    }
</script>

<style lang="scss">
    .row-search{
        &::before{
            content:' ';
            height: 1px;
            width: 100%;
            position: absolute;
            background-color: #D6D6D6;
            bottom: 0;
            left: 0;
        }
    }
    .search{
        .v-input__control{
            .v-input__slot{
                margin-bottom: 0px !important;
                &::before{
                    border: 0 !important;
                }
                label{
                    font-size: 12px;
                    color: #9E9D9D;
                }
            }
        }
        .v-text-field__details{
            min-height: 0px;
            display: none;
        }
    }

    .buttonAdvanced{
        font-size: 12px !important;
        text-transform: capitalize !important;
        color: #9E9D9D !important;

        &:hover{
            color: var(--v-primary-base)!important;
            path{
                fill:var(--v-primary-base);
            }
            &:before{
                background-color: transparent !important;
            }
        }
        &:focus{
            &:before{
                background-color: transparent !important;
            }
        }
        &.active{
            color: var(--v-primary-base)!important;
            path{
                fill:var(--v-primary-base);
            }
        }

    }

    .filter-advenced{
        .v-subheader{
            font-size: 12px;
            color:#9E9D9D;
        }
        .v-select__selection{
            font-size:12px;
        }
        .v-input__slot{
            font-size: 12px;
            label{
                font-size: 12px;
            }
        }
    }

</style>
